export default __webpack_public_path__ + "static/media/neusoft-logo.3c582e30.svg";